// @flow
/* eslint-disable no-use-before-define */

export type OndemandStatus = $Values<typeof ONDEMAND_STATUS>
export type OndemandStatusName = $Keys<typeof ONDEMAND_STATUS>

const ONDEMAND_STATUS = {
  PENDING: 'pending',

  // Waiting for a driver to accept the reservation
  WAIT_DRIVER: 'wait-driver',

  // Reservation is scheduled (meaning Mozio API will request it a few minutes before the ride time)
  SCHEDULED: 'scheduled',

  // Reservation is booked with the provider (meaning provider's API support pre-book and is handling ride scheduling)
  BOOKED: 'booked',

  // Pending payment authorization (do we get this status from the API ever?)
  PAYMENT_AUTH_PENDING: 'payment-auth-pending',

  // Driver is coming (app should be tracking the car)
  DRIVER_COMING: 'driver-coming',

  // Driver has arrived to pickup currentLocation
  DRIVER_ARRIVED: 'arrived',

  // Ride in progress - passenger inside the car
  IN_TRANSIT: 'in-transit',

  // FINAL STATUS: Failed to create reservation
  FAILED: 'failed',

  // FINAL STATUS: Server lost communication with the external API server
  LOST: 'lost',

  // FINAL STATUS: No driver was able to accept the reservation
  NO_DRIVER: 'no-driver',

  // FINAL STATUS: Failed to authorize payment
  PAYMENT_AUTH_FAILED: 'payment-auth-failed',

  // FINAL STATUS: User cancelled this reservation
  CANCELLED_BY_USER: 'cancelled-by-user',

  // FINAL STATUS: Driver cancelled this reservation
  CANCELLED_BY_DRIVER: 'cancelled-by-driver',

  // FINAL STATUS: Reservation has been completed - passenger has been dropped off
  COMPLETED: 'completed',

  // FINAL STATUS: Ride has been paid for
  PAID: 'paid',

  // FINAL STATUS: Ride has been paid through an external provider (we probably won't know how much it costed)
  PAID_THROUGH_PROVIDER: 'paid-through-provider',
}

export default ONDEMAND_STATUS
